import { useContext, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import build from '../../../Assets/images/build.svg'
import contribute from '../../../Assets/images/contribute.svg'
import develop from '../../../Assets/images/develop.svg'
import enjoy from '../../../Assets/images/enjoy.svg'
import './CourseOutline.css'
import './CourseOutlineModule.css'

import { useNavigate } from 'react-router-dom'
import { AppProvider } from '../../../ContextApi/AppContext'
import { API_URL, IMG_PATH } from '../../../server'

const CourseOutlineModule = ({ name, coursename }) => {
  const [subscription, setSubscription] = useState(false)
  const [courseKit, setCourseKit] = useState(false)
  const [preview, setPreview] = useState(false) // Fixed typo here: "setPrevew" should be "setPreview"

  // Extracting state from context
  const { state, setState, prev, setPrev, index, setIndex } =
    useContext(AppProvider)

  const registerid = sessionStorage.getItem('registerid')
  const token = sessionStorage.getItem('token')
  const navigate = useNavigate()

  // Set courseKit or preview modal based on the prop name
  useEffect(() => {
    if (name === 'coursekit') setCourseKit(true)
    if (name === 'preview') setPreview(true)
    mydetails()
  }, [name])

  // Fetch user details on component mount

  useEffect(() => {
    if (token && registerid) mydetails()
  }, [token, registerid])

  const mydetails = () => {
    fetch(API_URL + 'getUsers', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ _id: registerid })
    })
      .then(res => res.json())
      .then(result => {
        setSubscription(result?.data?.profile?.subscription || false)
        console.log(
          'subscriptionPlan',
          registerid,
          result?.data?.profile?.subscriptionPlan
        )
      })
      .catch(error => console.error('Error:', error))
  }

  const navsubscription = () =>
    navigate('/SettingsMainScreen/SettingSubscription', { state: 7 })

  return (
    <>
      {subscription ? (
        <Modal centered show={courseKit} className='flex items-center m-0 rad'>
          <Modal.Body className='modalbackgroundcolor  p-4 items-center rounded-lg'>
            <div className='flex justify-end w-full mb-2'>
              <button
                type='button'
                className='btn btn-close ms-ms-auto items-end'
                onClick={() => setCourseKit(false)}
              ></button>
            </div>
            <p className='cotitle1'>{coursename}</p>
            <p className='coursemodulekit'>
              {state?.courseKitpreviewHeaderText}
            </p>
            <p className='copara text-muted mb-3 '>
              {state?.courseKitDescription}
            </p>

            <hr />

            <p className='cotitle text-black font-bold mt-2'>
              Let's get started
            </p>
            <p className='copara text-muted mb-3 '>
              {state?.courseKitpreviewText}
            </p>

            <div className='w-full mt-4 rounded-[10px] overflow-hidden aspect-[1080/672]  shadow-custom'>
              <img
                src={IMG_PATH + state?.courseKitpreviewImage}
                alt='Course preview'
                className='w-full h-full object-cover'
              />
            </div>

            {/* <p className="copara mt-3 width-100%">
              Use the link here to access the tool:
              <a
                href={state?.courseKitpreviewLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'black', wordWrap: 'break-word', overflowWrap: 'break-word', display: 'block', maxWidth: '100%' }}
                className="text-break"
              >
                {state?.courseKitpreviewLink}
              </a>

            </p> */}
            <a
              href={state?.courseKitpreviewLink}
              target='_blank'
              rel='noopener noreferrer'
              className='subbuttonone text-center block p-2 mt-5'
              onClick={() => setCourseKit(false)}
            >
              Open Course Kit
            </a>
          </Modal.Body>
        </Modal>
      ) : (
        <Modal centered show={courseKit} className='flex items-center m-0 rad'>
          <Modal.Body className='bg-[#F5F3EE]  p-4 items-center rounded-lg'>
            <div className='flex justify-end w-full mb-2'>
              <button
                type='button'
                className='btn btn-close ms-ms-auto items-end'
                onClick={() => setCourseKit(false)}
              ></button>
            </div>
            <div>
              <div>
                <p className='cotitle1'>Your Pathway to Industry</p>
                <p className='coursemoduleprev'>
                  Skills,
                  <strong style={{ color: '#166479' }}>
                    Certifications,{' '}
                  </strong>{' '}
                  <strong className='copara'>and</strong>{' '}
                  <strong style={{ color: '#660076' }}>Opportunities</strong>.
                </p>
                <p className='copara'>
                  Join <strong>Recess Pathway</strong> to continue and:
                </p>
              </div>
              <div>
                <div className='d-flex align-items-center gap-3'>
                  <span>
                    <img className='subscribeimg' src={develop} />
                  </span>
                  <span className='copara'>
                    Develop in-demand skills through{' '}
                    <strong>structured courses and certifications.</strong>
                  </span>
                </div>
                <div className='d-flex align-items-center gap-3 mt-3'>
                  <span>
                    <img className='subscribeimg' src={build} />
                  </span>
                  <span className='copara'>
                    Build a standout resume with our{' '}
                    <strong>AI-powered resume builder</strong>{' '}
                    <span className='text-muted'>(on its way)</span>
                  </span>
                </div>
                <div className='d-flex align-items-center gap-3 mt-3'>
                  <span>
                    <img className='subscribeimg' src={contribute} />
                  </span>
                  <span className='copara'>
                    Contribute to real-world employer tasks through our industry
                    portal <span className='text-muted'>(on its way)</span>
                  </span>
                </div>
                <div className='d-flex align-items-center gap-3 mt-4'>
                  <span>
                    <img className='subscribeimg' src={enjoy} />
                  </span>
                  <span className='copara'>
                    Enjoy resource partner discounts on{' '}
                    <strong>tools, supplies, and more.</strong>
                  </span>
                </div>
              </div>
              <div className='mt-4 mb-4'></div>
              <button
                className='subbuttonone'
                onClick={() => navsubscription()}
              >
                Start your free trail today
              </button>
              <div
                className='copara mb-2 ms-4'
                style={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  paddingTop: 15
                }}
              >
                <p style={{ display: 'inline', margin: 0, fontSize: 10 }}>
                  You can also talk to your school about{' '}
                  <a
                    href='https://www.recess.education/schools'
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{ color: 'black', fontWeight: '600' }}
                  >
                    https://www.recess.education/schools
                  </a>
                </p>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}

      {subscription ? (
        <Modal centered show={preview} className='flex items-center m-0 rad'>
          <Modal.Body className='modalbackgroundcolor  p-4 items-center rounded-lg'>
            <div className='flex justify-end w-full mb-2'>
              <button
                type='button'
                className='btn btn-close ms-ms-auto items-end'
                onClick={() => setPreview(false)}
              ></button>
            </div>

            <p className='cotitle1'>{prev?.previewHeaderText}</p>
            <p className='coursemoduleprev'>Session Preview</p>
            <p className='text-muted copara mb-2'>{prev?.previewDescription}</p>
            <hr />
            <p className='cotitle text-black font-bold mt-2'>
              Let's get started
            </p>
            <p className='text-muted copara mb-2'>{prev?.previewText}</p>

            <img
              src={IMG_PATH + prev?.previewImage}
              style={{
                width: '100%',
                height: '12rem',
                borderRadius: '10px',
                marginTop: '15px'
              }}
            />

            {/* <p className=" d-flex flex-row copara mt-3 ali align-items-center justify-content-center" style={{ width: '100%' }}>
              Access a tool here:
              <Link
                to={prev?.previewLink}
                style={{
                  color: 'black',
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word',
                  display: 'block',
                  maxWidth: '100%',
                }}
                className="text-break"
              >
                {prev?.previewLink}
              </Link>
            </p> */}

            <a
              href={prev?.previewLink}
              target='_blank'
              rel='noopener noreferrer'
              className='subbuttonone text-center block p-2 mt-5'
              onClick={() => setPreview(false)}
            >
              View Session Guide
            </a>
            {/* <p className="coursemodule">What you need to practice</p> */}
          </Modal.Body>
        </Modal>
      ) : (
        <Modal centered show={preview} className='flex items-center m-0 rad'>
          <Modal.Body className='bg-[#F5F3EE]  p-4 items-center rounded-lg'>
            <div className='flex justify-end w-full mb-2'>
              <button
                type='button'
                className='btn btn-close ms-ms-auto items-end'
                onClick={() => setPreview(false)}
              ></button>
            </div>

            <div>
              <div>
                <p className='cotitle1'>Your Pathway to Industry</p>
                <p className='coursemoduleprev'>
                  Skills, Certifications,{' '}
                  <strong className='copara'>and</strong>{' '}
                  <strong style={{ color: '#660076' }}>Opportunities</strong>.
                </p>
                <p className='copara'>
                  Join <strong>Recess Pathway</strong> to continue and:
                </p>
              </div>
              <div>
                <div className='d-flex align-items-center gap-3'>
                  <span>
                    <img className='subscribeimg' src={develop} />
                  </span>
                  <span className='copara'>
                    Develop in-demand skills through{' '}
                    <strong>structured courses and certifications.</strong>
                  </span>
                </div>
                <div className='d-flex align-items-center gap-3 mt-3'>
                  <span>
                    <img className='subscribeimg' src={build} />
                  </span>
                  <span className='copara'>
                    Build a standout resume with our{' '}
                    <strong>AI-powered resume builder</strong>{' '}
                    <span className='text-muted'>(on its way)</span>
                  </span>
                </div>
                <div className='d-flex align-items-center gap-3 mt-3'>
                  <span>
                    <img className='subscribeimg' src={contribute} />
                  </span>
                  <span className='copara'>
                    Contribute to real-world employer tasks through our industry
                    portal <span className='text-muted'>(on its way)</span>
                  </span>
                </div>
                <div className='d-flex align-items-center gap-3 mt-4'>
                  <span>
                    <img className='subscribeimg' src={enjoy} />
                  </span>
                  <span className='copara'>
                    Enjoy resource partner discounts on{' '}
                    <strong>tools, supplies, and more.</strong>
                  </span>
                </div>
              </div>
              <div className='mt-4 mb-4'>
                <button
                  className='subbuttonone'
                  onClick={() => navsubscription()}
                >
                  Free trail completed, Please Subscribe..
                </button>
              </div>
              <div
                className='copara align-center'
                style={{ textAlign: 'center' }}
              >
                <p>
                  You can also talk to your school about{' '}
                  <a
                    href='https://www.recess.education/schools'
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{ color: '#007bff', textDecoration: 'underline' }} // Optional styling
                  >
                    https://www.recess.education/schools
                  </a>
                </p>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  )
}

export default CourseOutlineModule
